import React, { MouseEventHandler } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Properties from './Properties';
import SanityImage from '@components/Shared/SanityImage';
import { MyProjectFragment } from '@src/generated/graphql';
import SanityText from '@components/Shared/SanityText';
import ChakraButton from '@components/Shared/ChakraButton/ChakraButton';

const TopRow: React.FC<
  Pick<MyProjectFragment, 'topImage' | 'properties' | 'topTextRaw'>
> = ({ topImage, properties, topTextRaw }) => {
  const handleClick: MouseEventHandler = (event) => {
    const el = document.getElementById('photo-gallery');
    event.preventDefault();
    el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <Flex
      justify="space-between"
      mb={[5, null, 67]}
      direction={['column', null, 'row']}
    >
      <Box flex={2} mr={[null, null, '54px']}>
        <SanityImage sanityImage={topImage} width={709} height={493} />
      </Box>
      <Flex
        flex={1}
        direction="column"
        alignContent="space-between"
        align="flex-start"
      >
        <Box flex={1} my={[5, null, 0]}>
          <Properties properties={properties} />

          <ChakraButton mt="24px" onClick={handleClick}>
            Photo Gallery
          </ChakraButton>
        </Box>

        <SanityText
          content={topTextRaw}
          maxW={[null, null, '353px']}
          withoutBottomMargin
        />
      </Flex>
    </Flex>
  );
};

export default TopRow;
